import UFOLabel from '@atlassian/react-ufo/label';

export default UFOLabel;
